<template>
    <div class="left-side-menu">
        <div class="slimscroll-menu">
            <div id="sidebar-menu" style="height: 550px; overflow: auto; position: relative; display: block">
                <ul class="metismenu" id="side-menu">
                    <li class="menu-title">
                        {{ $t('string.msg.leftsidebar.label.title') }}
                    </li>
                    <li
                        v-bind:class="{
                            hidden: isAdminMaster() || hasType('FLEET_DRIVER'),
                        }"
                    >
                        <router-link to="/dashboard" class="cursor-pointer">
                            <i class="dripicons-meter" style="color: #343b4a"></i>
                            <span>{{ $t('string.msg.menu.dashboard.label.title') }}</span>
                        </router-link>
                    </li>
                    <li
                        v-bind:class="{
                            hidden: isAdminMaster() || !hasType('FLEET_DRIVER'),
                        }"
                    >
                        <router-link to="/dashboard-fleet-driver" class="cursor-pointer">
                            <i class="dripicons-meter" style="color: #343b4a"></i>
                            <span>{{ $t('string.msg.menu.dashboard.label.title') }}</span>
                        </router-link>
                    </li>
                    <li :class="{ hidden: !hasType('PART_SUPPLIER') }" class="item-with-submenus product">
                        <a href="javascript: void(0);">
                            <i class="mdi mdi-wrench" style="color: #343b4a"></i>
                            <span>{{ $t('string.msg.menu.register.parts.label.title') }}</span>
                            <span class="menu-arrow"></span>
                        </a>
                        <ul class="nav-second-level mm-collapse" aria-expanded="false">
                            <li>
                                <a @click="to('perfil-trucks')" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.parts.trucks.configuration.label.title') }}</span>
                                </a>
                            </li>
                            <li>
                                <router-link to="/perfil-trucks-trailer" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.parts.trucks.trailer.configuration.label.title') }}</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li v-bind:class="{ hidden: !hasType('SERVICE_PROVIDER') }" class="item-with-submenus product">
                        <a href="javascript: void(0);">
                            <i class="mdi mdi-movie-roll" style="color: #343b4a"></i>
                            <span>{{ $t('string.msg.menu.register.services.label.title') }}</span>
                            <span class="menu-arrow"></span>
                        </a>
                        <ul class="nav-second-level mm-collapse" aria-expanded="false">
                            <li>
                                <router-link to="/perfil-trucks-service" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.parts.services.configuration.label.title') }}</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li v-bind:class="{ hidden: !hasType('CERTIFIER') }" class="item-with-submenus product">
                        <a href="javascript: void(0);">
                            <i class="mdi mdi-book-outline" style="color: #343b4a"></i>
                            <span>{{ $t('string.msg.menu.register.certified.label.title') }}</span>
                            <span class="menu-arrow"></span>
                        </a>
                        <ul class="nav-second-level mm-collapse" aria-expanded="false">
                            <li>
                                <router-link to="/perfil-certifies" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.parts.certifies.configuration.label.title') }}</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="item-with-submenus product">
                        <a href="javascript: void(0);">
                            <i class="fe-settings noti-icon" style="color: #343b4a"></i>
                            <span>{{ $t('string.msg.menu.configurations.label.title') }}</span>
                            <span class="menu-arrow"></span>
                        </a>
                        <ul class="nav-second-level mm-collapse" aria-expanded="false">
                            <li>
                                <router-link to="/company-registration" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.company.registration.label.title') }}</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{ hidden: isAdminMaster() }">
                                <router-link to="/work-hours" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.additional.informations.label.title') }}</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{ hidden: isAdminMaster() }">
                                <router-link to="/payment-method" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.payment.methods.label.title') }}</span>
                                </router-link>
                            </li>

                            <li>
                                <router-link to="/crud-user" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.crud.user.label.title') }}</span>
                                </router-link>
                            </li>

                            <li>
                                <router-link to="/change-password" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.change.password.label.title') }}</span>
                                </router-link>
                            </li>

                            <li>
                                <router-link to="/terms" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.terms.label.title') }}</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li v-bind:class="{ hidden: !isAdminMaster() }" class="item-with-submenus product">
                        <a href="javascript: void(0);">
                            <i class="fab fa-wpforms" style="color: #343b4a"></i>
                            <span>{{ $t('string.msg.menu.manage.label.title') }}</span>
                            <span class="menu-arrow"></span>
                        </a>
                        <ul class="nav-second-level mm-collapse" aria-expanded="false">
                            <li>
                                <router-link to="/panic-alert" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.alert.panic.label.title') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/crud-companies" class="cursor-pointer">
                                    <span>{{ $t('string.msg.companies.manager.user.label.title') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/gas-station" class="cursor-pointer">
                                    <span>{{ $t('string.msg.system.config.gasstation') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/trucker" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.register.trucker.label.title') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/truck-admin" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.register.truck.label.title') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/trucktrailer-admin" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.register.trucktrailer.label.title') }}</span>
                                </router-link>
                            </li>
                            <!-- <li>
                                <router-link to="list-trucks" class="cursor-pointer">
                                    <span>{{$t("string.msg.menu.list.trucks.label.title")}}</span>
                                </router-link>
                            </li> -->
                            <li>
                                <router-link to="/list-orders" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.list.trucks.label.requests') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/list-user" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.crud.user.label.title') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/request-admin" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.request.fleetdriver.label.title') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/approve-trucker" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.approve.trucker.label.title') }}</span>
                                </router-link>
                            </li>

                            <li>
                                <router-link to="/curriculums" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.curriculum.label.title') }}</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{ hidden: !isAdminMaster() }">
                                <router-link to="/bank-slips" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.bank.slips.label.title') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/banner" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.banner.label.title') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/health" class="cursor-pointer">
                                    <span>{{ $t('string.msg.collect') }}</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li v-bind:class="{ hidden: !hasType('FLEET_DRIVER') || !isAdminMaster() }" class="item-with-submenus product">
                        <a href="javascript: void(0);">
                            <i class="fab fa-wpforms" style="color: #343b4a"></i>
                            <span>{{ $t('string.msg.menu.manage.fleet.label.title') }}</span>
                            <span class="menu-arrow"></span>
                        </a>

                        <ul class="nav-second-level mm-collapse" aria-expanded="false">
                            <li>
                                <router-link to="/panic-alert-fleetdriver" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.alert.panic.label.title') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/trucker-fleet-driver" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.register.trucker.label.title') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/crud-truck" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.register.truck.label.title') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/crud-trucktrailer" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.register.trucktrailer.label.title') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/fleetdriver-request" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.request.fleetdriver.label.title') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/my-orders" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.myorders.fleetdriver.label.title') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/approve-trucker-fleet-driver" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.validate.trucker.fleetdriver.label.title') }}</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/curriculums" class="cursor-pointer">
                                    <span>{{ $t('string.msg.menu.curriculum.label.title') }}</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <router-link to="/chat" class="cursor-pointer">
                            <i class="dripicons-message" style="color: #343b4a"></i>
                            <span>{{ $t('string.msg.chat.menu.label.title') }}</span>
                        </router-link>
                    </li>
                    <li v-bind:class="{ hidden: !isAdminMaster() }">
                        <router-link to="/chart" class="cursor-pointer">
                            <i class="dripicons-meter" style="color: #343b4a"></i>
                            <span>{{ $t('string.msg.chart.menu.label.title') }}</span>
                        </router-link>
                    </li>
                    <li v-bind:class="{ hidden: isAdminMaster() }">
                        <router-link to="/chart-company" class="cursor-pointer">
                            <i class="dripicons-meter" style="color: #343b4a"></i>
                            <span>{{ $t('string.msg.chart.menu.label.title') }}</span>
                        </router-link>
                    </li>
                    <li v-bind:class="{ hidden: !isAdminMaster() }">
                        <router-link to="/history-orders-admin" class="cursor-pointer">
                            <i class="fa fa-history" aria-hidden="true" style="color: #343b4a"></i>
                            <span>{{ $t('string.msg.history.orders.admin.label.title') }}</span>
                        </router-link>
                    </li>
                    <li v-bind:class="{ hidden: !isAdminMaster() }" class="item-with-submenus product">
                        <a href="javascript: void(0);">
                            <i class="dripicons-document" aria-hidden="true" style="color: #343b4a"></i>
                            <span>{{ $t('string.msg.report.admin.label.title') }}</span>
                            <span class="menu-arrow"></span>
                        </a>
                        <ul class="nav-second-level mm-collapse" aria-expanded="false">
                            <li v-bind:class="{ hidden: !isAdminMaster() }">
                                <router-link to="/report-truck" class="cursor-pointer">
                                    <i class="" aria-hidden="true" style="color: #343b4a"></i>
                                    <span>{{ $t('string.msg.report.truck.admin.label.title') }}</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{ hidden: !isAdminMaster() }">
                                <router-link to="/report-trucker" class="cursor-pointer">
                                    <i class="" aria-hidden="true" style="color: #343b4a"></i>
                                    <span>{{ $t('string.msg.report.trucker.admin.label.title') }}</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{ hidden: !isAdminMaster() }">
                                <router-link to="/indication-uses" class="cursor-pointer">
                                    <i class="" aria-hidden="true" style="color: #343b4a"></i>
                                    <span>{{ $t('string.msg.report.trucker.indication.uses.title') }}</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{ hidden: !isAdminMaster() }">
                                <router-link to="/companies-found" class="cursor-pointer">
                                    <i class="" aria-hidden="true" style="color: #343b4a"></i>
                                    <span>{{ $t('string.msg.report.companies.found.uses.title') }}</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{ hidden: !isAdminMaster() }">
                                <router-link to="/reports/terms-accepted" class="cursor-pointer">
                                    <i class="" aria-hidden="true" style="color: #343b4a"></i>
                                    <span>{{ $t('string.msg.report.terms-accepted.title') }}</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li v-bind:class="{ hidden: !isAdminMaster() }" class="item-with-submenus product">
                        <a href="javascript: void(0);">
                            <i class="fab fa-wpforms" style="color: #343b4a"></i>
                            <span>{{ $t('string.msg.menu.system.config') }}</span>
                            <span class="menu-arrow"></span>
                        </a>

                        <ul class="nav-second-level mm-collapse" aria-expanded="false">
                            <li v-bind:class="{ hidden: !isAdminMaster() }">
                                <router-link to="/system-config-family" class="cursor-pointer">
                                    <i class="" aria-hidden="true" style="color: #343b4a"></i>
                                    <span>{{ $t('string.msg.system.config.family') }}</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{ hidden: !isAdminMaster() }">
                                <router-link to="/system-config-service" class="cursor-pointer">
                                    <i class="" aria-hidden="true" style="color: #343b4a"></i>
                                    <span>{{ $t('string.msg.system.config.service') }}</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{ hidden: !isAdminMaster() }">
                                <router-link to="/system-config-manufacturer" class="cursor-pointer">
                                    <i class="" aria-hidden="true" style="color: #343b4a"></i>
                                    <span>{{ $t('string.msg.system.config.manufacturer') }}</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{ hidden: !isAdminMaster() }">
                                <router-link to="/system-config-model" class="cursor-pointer">
                                    <i class="" aria-hidden="true" style="color: #343b4a"></i>
                                    <span>{{ $t('string.msg.system.config.model') }}</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{ hidden: !isAdminMaster() }">
                                <router-link to="/system-config-gasstation" class="cursor-pointer">
                                    <i class="" aria-hidden="true" style="color: #343b4a"></i>
                                    <span>{{ $t('string.msg.system.config.gasstation') }}</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
                <div style="margin-left: 30px; color: green">
                    <label>{{ $t('string.msg.platform.free.trial') }}</label>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script>
import Controller from './CrtLeftSideBar'

export default {
    name: 'LeftSideBar',
    components: {},
    data() {
        return {
            errors: [],
            titleToast: null,
            messageToast: null,
            messageIdToast: null,
            user: {
                serviceTypes: [],
            },
        }
    },
    methods: Controller.methods,
    created() {
        Controller.init(this)
    },
    mounted() {
        $('.item-with-submenus > a').click(function () {
            $(this).parent().toggleClass('mm-active')
            $(this).parent().children('ul.nav-second-level.mm-collapse').toggleClass('mm-show')
        })
    },
}
</script>

<style scoped>
</style>